// ABOUTME: My job's dates and hours written as the job page's sections write them ("03. Nov. 2026", "16 Std./Wo."), for
// ABOUTME: "Dein Job" and the contract changes when they are drawn as sections of that page (PJL).
import { formatInTimeZone } from 'date-fns-tz';
import { getTransWithParams } from 'modules/i18n';
import { formatDay, hoursLabel } from 'modules/jobListings/utils';
import { DEFAULT_TIMEZONE } from 'utils/date';

/** The Berlin day of a date or an instant, "yyyy-MM-dd". */
export const berlinDay = (value: string): string =>
  formatInTimeZone(new Date(value), DEFAULT_TIMEZONE, 'yyyy-MM-dd');

/** A day as the job page writes it. */
export const jobPageDay = (value: string): string =>
  formatDay(berlinDay(value));

/** Weekly minutes as the job page writes them. */
export const jobPageWeeklyHours = (minutes: number): string =>
  getTransWithParams('jobs.card.hoursPerWeek', {
    hours: hoursLabel(minutes, minutes)
  });
